import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ArrowLeftIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M18.98 11.03H7.42l5.33-5.33c.38-.38.38-1.05 0-1.43a1.04 1.04 0 0 0-1.43 0l-6.97 6.98c-.08.07-.15.22-.23.3-.07.22-.07.52 0 .75.08.15.15.22.23.3l6.97 6.97c.38.38 1.05.38 1.43 0 .38-.37.38-1.05 0-1.42l-5.33-5.32h11.56a1 1 0 0 0 .97-.98c0-.53-.38-.82-.97-.82Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ArrowLeftIcon;
